import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  StripeCheckoutSessionSummaryV1Response,
} from '../models';
import { HttpClient } from '@angular/common/http';
import { StripeService } from './stripe.service';

/* istanbul ignore next */
export class StripePlatformService extends StripeService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  createCheckoutSession(
    tenantId: string,
    payload: CreateCheckoutSessionRequest,
  ): Observable<CreateCheckoutSessionResponse> {
    return this.httpClient.post<CreateCheckoutSessionResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/checkout/sessions`,
      payload,
    );
  }

  public getCheckoutSessionSummaryV1(
    tenantId: string,
    stripeAccountId: string,
    stripeSessionId: string,
  ): Observable<StripeCheckoutSessionSummaryV1Response> {
    return this.httpClient.get<StripeCheckoutSessionSummaryV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/checkout/account/${stripeAccountId}/sessions/${stripeSessionId}`,
    );
  }
}
